/*eslint-disable */
import _ from 'lodash'

export default {
  updateMessages (state, ui) {
    // console.log('MSG UPDATE',ui)
    let items = state.items
    items = _.unionBy(ui, items, 'mainId')
    state.items = items
  },

  deleteMessage (state, msgId) {
    // Convert msgId to number once
    const messageId = Number(msgId)

    // Use Vue.set to ensure reactivity
    state.items = state.items.filter(item =>
      Number(item.mainId) !== messageId
    )
  }
}


